import React, { useState } from 'react';
import { Link } from "react-router-dom";
import logo from 'imagens/logo-drogas-2.png';
import CabecalhoLink from "components/CabecalhoLink";
import styles from './Cabecalho.module.css';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { useDevice } from 'components/DeviceContext.js';

const Cabecalho = () => {
    const { isMobile } = useDevice();
    const [openDrawer, setOpenDrawer] = useState(false);

    const toggleDrawer = () => {
        setOpenDrawer(!openDrawer);
    };

    return (
        <header className={styles.header}>
            <Link to="./">
                <img
                    className="logoCnm"
                    src={logo}
                    alt="Logo da CNM"
                    style={{ maxWidth: isMobile ? '50%' : '100%', height: 'auto', padding: '10px' }}
                />
            </Link>

            {isMobile ? (
                <>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleDrawer}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Drawer
                        anchor="right"
                        open={openDrawer}
                        onClose={toggleDrawer}
                    >
                        <div style={{ width: '200px' }}>
                            <CabecalhoLink />
                            <Link to="/login" style={{
                                display: 'block',
                                borderRadius: '8px',
                                border: '1px solid var(--branco)',
                                color: 'var(--branco)',
                                padding: '8px',
                                textDecoration: 'none',
                                textAlign: 'center',
                                margin: '10px 0'
                            }}>
                                Login
                            </Link>
                        </div>
                    </Drawer>
                </>
            ) : (
                <nav>
                    <CabecalhoLink />
                </nav>
            )}
        </header>
    );
};

export default Cabecalho;
